import { FC, useState, useEffect } from "react";
import styled from "styled-components";
import moment from "moment";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import MaskedTextInput from "react-text-mask";
import { IconCalendar } from "../../assets/icons/IconCalendar";

const StyledInputControl = styled.input`
  cursor: pointer !important;
`;

const StyledInputContainer = styled.div`
  position: relative;
`;

const StyledIconContainer = styled.div`
  position: absolute;
  pointer-events: none;
  right: 10px;
  transform: translateY(-50%);
  top: 50%;
`;

const Datepicker: FC = (props: any): JSX.Element => {
  const [minDate, setMinDate] = useState("");
  const [date, setDate] = useState(
    props.value ? new Date(moment(props.value).utc(false).format()) : undefined
  );

  const formatMinDate = () => {
    const formattedDate = moment().format("YYYY-MM-DD");

    setMinDate(formattedDate);
  };

  useEffect(() => {
    formatMinDate();
  }, []);

  const handleChangeDate = (date: Date | any) => {
    setDate(date);

    if (date && date?.toString()?.length) {
      props.onChange(moment(date || "0").format("yyyy-MM-DD"));
    }
  };

  return (
    <DatePicker
      id={props.id}
      className="form-control"
      selected={date}
      onChange={handleChangeDate}
      required={props.required}
      name="date"
      onBlur={() => props.onBlur(props.id, date)}
      dateFormat="MM/dd/yyyy"
      customInput={
        <MaskedTextInput
          type="text"
          mask={[/\d/, /\d/, "/", /\d/, /\d/, "/", /\d/, /\d/, /\d/, /\d/]}
          render={(ref, props) => (
            <StyledInputContainer>
              <StyledInputControl ref={ref as any} {...props} />
              <StyledIconContainer>
                <IconCalendar />
              </StyledIconContainer>
            </StyledInputContainer>
          )}
        />
      }
    />
  );
};

export default Datepicker;
